import React from 'react'
import Confetti from 'react-dom-confetti'

const ConfettiComp = ({ active }) => {
  const config = {
    angle: 45,
    spread: 360,
    startVelocity: 50,
    elementCount: 300,
    dragFriction: 0.12,
    duration: 3000,
    stagger: 2,
    width: '10px',
    height: '10px',
    perspective: '400px',
    colors: ['#2b580c', '#f7b71d', '#afa939', '#fdef96'],
  }
  return (
    <div style={{ zIndex: 100 }}>
      <Confetti active={active} config={config} />
    </div>
  )
}

export default ConfettiComp
